<template>
  <div
    class="scence_box"
    :class="scenceCard != null ? (scenceCard.length>0 ? '':'card_content_backimage'):''"
  >
    <el-row :gutter="0">
      <div
        v-for="(item,index) in scenceCard"
        :key="index"
        class="scence_card"
        :class="[ item.ischecked?'checkCss':'',fromMap?'fromMap':'',]"
        @click="cardset(item)"
      >
        <el-checkbox
          v-if="is_check"
          v-model="item.ischecked"
          :class="isradio?'scence_only':'scence_more'"
          @change="removeTree(item)"
          @click.native.stop
        />
        <template v-if="item.SceneType ==0">
          <div class="scence_card_header shangban">
            <img src="../../assets/img/sun1.png">
            <span class="scence_card_type">
              <!-- {{ $t('sceneCard.mode2') }} -->
            </span>
            <span
              v-if="item.havecheck"
              class="have_state"
            >{{ $t('sceneCard.selected') }}</span>
          </div>
        </template>
        <template v-else-if="item.SceneType ==1">
          <div class="scence_card_header xiaban">
            <img
              v-if="item.ShowEntry === 4"
              src="../../assets/img/tianmu.png"
            >
            <img
              v-else
              src="../../assets/img/moon.png"
            >
            <span class="scence_card_type">
              <!-- {{ $t('sceneCard.mode1') }} -->
            </span>
            <span
              v-if="item.havecheck"
              class="have_state"
            >{{ $t('sceneCard.selected') }}</span>
          </div>
        </template>

        <template v-else-if="item.SceneType ===2">
          <div class="scence_card_header xiuxi">
            <img src="../../assets/img/bei.png">
            <span class="scence_card_type">
              <!-- {{ $t('sceneCard.mode3') }} -->
            </span>
            <span
              v-if="item.havecheck"
              class="have_state"
            >{{ $t('sceneCard.selected') }}</span>
          </div>
        </template>
        <template v-else-if="item.SceneType ===3">
          <div class="scence_card_header clear">
            <img src="../../assets/img/clear.png">
            <span class="scence_card_type">
              <!-- {{ $t('sceneCard.mode4') }} -->
            </span>
            <span
              v-if="item.havecheck"
              class="have_state"
            >{{ $t('sceneCard.selected') }}</span>
          </div>
        </template>
        <template v-else-if="item.SceneType ===4">
          <div class="scence_card_header yingji">
            <img src="../../assets/img/tan.png">
            <span class="scence_card_type">
              <!-- {{ $t('sceneCard.mode5') }} -->
            </span>
            <span
              v-if="item.havecheck"
              class="have_state"
            >{{ $t('sceneCard.selected') }}</span>
          </div>
        </template>
        <template v-else-if="item.SceneType ===5">
          <div class="scence_card_header nomode">
            <img src="../../assets/img/stop.png">
            <span class="scence_card_type">
              <!-- {{ $t('sceneCard.mode0') }} -->
            </span>
            <span
              v-if="item.havecheck"
              class="have_state"
            >{{ $t('sceneCard.selected') }}</span>
          </div>
        </template>
        <template v-else>
          <div class="scence_card_header shangban">
            <img src="../../assets/img/sun1.png">
            <span class="scence_card_type">
              <!-- {{ $t('sceneCard.mode2') }} -->
            </span>
            <span
              v-if="item.havecheck"
              class="have_state"
            >{{ $t('sceneCard.selected') }}</span>
          </div>
        </template>
        <div v-if="fromMap" class="SceneName" :title="item.SceneName">
          {{ item.SceneName }}
        </div>
        <div class="scence_card_body">
          <div v-if="!fromMap" class="scence_card_ads">
            <span v-if="item.WellSkyTemplateId!== 0 || item.ShowEntry === 7 || item.ShowEntry === 8" class="scence_card_ads_describle">{{ $t('scene.singleDevice') }}</span>
            <span> {{ item.SceneName }}</span>
          </div>
          <div class="scence_card_state de_scence_card_state">
            <span>{{ $t('sceneCard.state') }}</span><span :class="item.ConfigStatus!=1?'redfont':''">{{ item.ConfigStatus==0?$t('sceneCard.configuration'):item.ConfigStatus==1?$t('sceneCard.allsuccess'):item.ConfigStatus==2?$t('sceneCard.onesuccess'):item.ConfigStatus==3?$t('sceneCard.allfail'):$t('sceneCard.invalid') }}</span>
          </div>
          <div class="scence_card_block text-ellipsis">
            <span>{{ $t('sceneCard.block') }}</span>{{ item.ParentAreaNames }}
          </div>
          <div class="scence_card_button">
            <template v-if="!nocall && showReport">
              <button
                :class="nocall?'eventNone':''"
                :style="showReport?'width: 45%;float:left;':''"
                @click.stop="goset(item)"
              />
              <button
                style="width:45%;float:right;"
                @click.stop="goReprot(item, $event)"
              >
                {{ $t('sceneCard.readReprot') }}
              </button>
            </template>
            <template v-else-if="!nocall && !isMonitor && item.AutoTemplateParams?.DataContent?.isCanControl !== false">
              <OppleAuth code="CallScene" :force-show="$store.state.isPassPermission">
                <button
                  :class="nocall?'eventNone':''"
                  @click.stop="goset(item)"
                >
                  {{ $t('sceneCard.go') }}
                </button>
              </OppleAuth>
            </template>
            <template v-else-if="item.AutoTemplateParams?.DataContent?.isCanEdit === false">
              <div style="height: 25px;" />
            </template>
            <template v-if="showReport && item.AutoTemplateParams?.DataContent?.isCanEdit !== false">
              <button @click.stop="goReprot(item, $event)">
                {{ $t('sceneCard.readReprot') }}
              </button>
            </template>
          </div>
        </div>
      </div>
      <!-- <VirtualList
      data-key="SceneNo"
      :list="scenceCard"
      :cell="sceneListCard"
      :is-horizontal="true"
      :extra-props="extraProps"
      :wrap-width="280"
      :keeps="6"
    /> -->
    </el-row>
  </div>
</template>

<script>
import { Call } from '@/axios/IScene.js'
import { alerterror, alertsuccess, warning } from '@/assets/js/common.js';
import { deleteLimitNumber } from '@assets/utils'
export default {
  props: ['scenceCard', 'is_check', 'isradio', 'noclick', 'nocall', 'showReport', 'badgeNum','fromMap','isMonitor','requireMaxSence','maxSence','hasSelectSence'],
  data () {
    return {

    }
  },
  computed: {
    extraProps() {
      return {
        extraProps: {
          cardset: this.cardset,
          removeTree: this.removeTree,
          goset: this.goset,
          goReprot: this.goReprot,
          is_check: this.is_check,
          isradio: this.isradio,
          nocall: this.nocall,
          showReport: this.showReport,
        },
      };
    },
  },
  destroyed () {
    if (this.$el && this.$el.__vue__) {
      this.$el.__vue__ = null
    }
    this._vnode = null
  },

  methods: {
    /* 执行场景 接口返回数据处理
    * rs 接口返回数据包
    */
    functionDoCall (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode);
        this.$emit('updateLastScene');
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    /* 点击执行场景
    * item 场景对象
    */
    doCall (item) {
      let para = { sceneNo: item.SceneNo }
      Call(para, this.functionDoCall)
      para = null
    },
    /* 点击执行场景
    * item 场景对象
    */
    goset (item) {
      this.doCall(item)
    },
    /* 点击查看场景
    * item 场景对象
    */
    goReprot (item, event) {
      this.$emit('showReportEvent', [item, event])
    },
    /* 点击进行场景卡片的 选中与步选中
    * val 场景对象
    */
    cliclChoose (val) {
      if (this.isradio) {
        this.scenceCard.forEach(n => {
          n.ischecked = false
        })
        val.ischecked = true
      } else {
        if(this.requireMaxSence && !val.ischecked){
           const hasSelct = this.scenceCard.filter(item => item.ischecked).length
           if(hasSelct+this.hasSelectSence >=this.maxSence){

             let str =  this.$t('deviceMsg.maxScreenSettingTips').replace('{{MaxCount}}', `${this.maxSence}`)
             warning(this,str)
             return
           }
        }

        const isTianmuChecked = this.scenceCard.filter(item =>  item.WellSkyTemplateId !== 0 && item.ischecked)
        if(isTianmuChecked.length >=1) {
          if(isTianmuChecked[0].WellSkyTemplateId !== val.WellSkyTemplateId && val.WellSkyTemplateId !== 0){
            val.ischecked = false
            warning(this, this.$t('scene.singleDeviceOne'))
            return
          }
        }

        if (this.badgeNum >= deleteLimitNumber) return
        val.ischecked = !val.ischecked
      }
    },
    /* 将选中的对象 传值给调用的页面
    * val 场景对象
    */
    removeTree (val) {
      this.cliclChoose(val)

      this.$emit('removeTree', [this.scenceCard, val])
    },
    /* 场景卡片对象 如果是选择场景 则点击选中  如果不是则进入场景详情
    * val 场景对象
    */
    cardset (val) {
      if (this.is_check) {
        // 点击选中选项卡
        this.removeTree(val)
      } else if (!this.noclick) {
          //地图监控模式下不可点击直接执行场景
          if(this.isMonitor){
            this.doCall(val)
          } else {
            if (val && val.AutoTemplateParams?.DataContent?.isCanEdit === false) {
              warning(this, this.$t("scene.tianmuNoGo"));
              return;
            }

            this.$emit('godetail', val)
          }
          // this.doFindDevice(val.VDeviceId,val.ChildId);
        }
    }
  }
}
</script>

<style scoped="scoped" lang="scss">
/* 场景模式组件	 */
$bgcolor1: linear-gradient(-70deg, #6b99d9, #b3cbec);
$bgcolor2: linear-gradient(-70deg, #f3b566, #f9d9ae);
$bgcolor3: linear-gradient(-70deg, #70c789, #b5e2c2);
$bgcolor4: linear-gradient(-70deg, #5eb5af, #eef1f9);
$bgcolor5: linear-gradient(-70deg, #f26b5d, #f7a591);
$bgcolor6: linear-gradient(-70deg, #686d7b, #a7adb5);
$fontsize: 12px;
$color1: #a8a8a8;
$color2: #1f1f1f;
.redfont {
  color: #f26b5d !important;
}
.xiaban {
  background: $bgcolor1;
}
.shangban {
  background: $bgcolor2;
}
.xiuxi {
  background: $bgcolor3;
}
.clear {
  background: $bgcolor4;
}
.yingji {
  background: $bgcolor5;
}
.nomode {
  background: $bgcolor6;
}

.scence_card_header .have_state{
  top:12px;
}

.scence_card {
  height: 247px;
  background-color: #fefefe;
  border-radius: 3px;
  border: solid 1px #dde2ea;
  display: inline-block;
  float: left;
  position: relative;
  .scence_only {
    ::v-deep .el-checkbox__inner {
      border-radius: 2px;
    }
  }
  .el-checkbox{ 
    top:12px
  }
  .el-checkbox__inner
  .scence_card_header {
    height: 107px;
    position: relative;
  
    img {
      display: inline-block;
      margin-left: 40px;
      margin-top: 20px;
    }
    .scence_card_type {
      font-size: 16px;
      color: #ffffff;
      display: inline-block;
      line-height: 107px;
      position: absolute;
      margin-left: 25px;
    }
  }
  .SceneName{
    position: absolute;
    left:50px;
    top: 10px;
    color:#ffffff;
    font-size: 14px;
    font-weight: 500;
    width: 70px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;  
    &:hover{
      // overflow: visible;
    }
  }
  .scence_card_body {
    font-size: $fontsize;
    line-height: 20px;
    padding: 15px 18px;
    .scence_card_ads {
      display: flex;
      font-size: 14px;
      color: $color5;
      margin-bottom: 5px;
      &_describle{
        color:#fff;
        background: #1C45A4;
        padding: 2px 5px;
        font-size: 12px;
        border-radius: 4px;
        margin-right: 10px;
      }
    }
    .scence_card_state {
      color: $color2;
      span {
        color: $color1;
      }
    }
    .scence_card_block {
      color: $color2;
      span {
        color: $color1;
      }
    }
    .scence_card_button {
      margin-top: 10px;
      button {
        width: 100%;
        height: 30px;
        border-radius: 3px;
        border: solid 1px #ced3db;
        background: #fff;
        color: #8a94a4;
        outline: none;
      }
    }
  }
}
.fromMap{
  background: linear-gradient(284deg, #283166 -1%, #181A2D 91%);
  height: 101px !important;
  border-radius: 4px;
  border:none;
  .scence_card_body{
    height: 60px;
    .scence_card_state{
      color: rgba(255, 255, 255, 0.51);
      margin-top: 8px;
      span {
        color: rgba(255, 255, 255, 0.51);
      }
    }
    .scence_card_block {
      color: rgba(255, 255, 255, 0.51);
      margin-top: 4px;
      span {
        color: rgba(255, 255, 255, 0.51);
      }
    }
   
  }
  .scence_card_header{
    background: linear-gradient(270deg, #2C4A96 0%, #181A2D 100%);
    height: 41px !important;
    display: flex;
    align-items: center;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    img{
      margin: 0px !important;
    }
  }
  &:hover{
     box-shadow: 0px 8px 14px #beccda;
   }
}
.scence_box{
  height: 101%;
}
</style>